export const BaseEnvironment = {
  COMPANY_CONTACT_TYPE_ID: 3,
  DEFAULT_DIALOG_WIDTH: '365px',
  CAPTCHA_KEY: '6LeREoYkAAAAANmH4CbGOolpEsa2yIAQztbgQL4m',
};
